import { createGenericSlice } from '../../../../../utils/slices'
import { DEFAULT_JOBSETTINGS_STATE } from '../../../common/constants'

export const jobSettingsSlice = createGenericSlice({
  name: 'jobSettings',
  initialState: DEFAULT_JOBSETTINGS_STATE,
  reducers: {
    modifyDesignInfoCalculation: (state, action) => {
      const { name, value } = action.payload

      state.designInformations[name] = value
    },
  },
})

export const jobSettingsActions = jobSettingsSlice.actions
